import { CREATE_EVENT_OBJECT, CREATE_EVENT, CREATE_EVENT_SUCCESS, CREATE_EVENT_FAIL,
  CATEGORYSPECIFIC_LOAD, CATEGORYSPECIFIC_SUCCESS, CATEGORYSPECIFIC_FAIL, CREATE_EVENT_SESSION,
  COOWNER_PROFILE_ID_LOAD, COOWNER_PROFILE_ID_LOAD_SUCCESS, COOWNER_PROFILE_ID_LOAD_FAIL, CAPTURE_CELEBRITY_TITLE
 } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: {},
  coOwnerProfileId: {},
  extraData: {},
  celebrityTitle: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CATEGORYSPECIFIC_LOAD:
      return {
        ...state,
        loading: true,
      };
    case CATEGORYSPECIFIC_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'CategorySpecific', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case CATEGORYSPECIFIC_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case CREATE_EVENT:
      return {
        ...state,
        loading: true,
      };
    case CREATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'createEvent', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case CREATE_EVENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case COOWNER_PROFILE_ID_LOAD:
      return {
        ...state,
        loading: true,
      };
    case COOWNER_PROFILE_ID_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        coOwnerProfileId: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case COOWNER_PROFILE_ID_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case CREATE_EVENT_OBJECT: {
      return Object.assign({}, state, action.data);
    }
    case CREATE_EVENT_SESSION: {
      return Object.assign({}, state, action.data);
    }
    case CAPTURE_CELEBRITY_TITLE: {
      return {
        ...state,
        celebrityTitle: action.celebrityTitle,
      };
    }
    default: {
      return state;
    }
  }
}

